import script from "./SpendingDonutChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpendingDonutChart.vue?vue&type=script&setup=true&lang=ts"

import "./SpendingDonutChart.vue?vue&type=style&index=0&id=61cadfd9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61cadfd9"]])

export default __exports__